import request from '@/utils/request'

//获取消息列表
export function noticeList(query) {
  return request({
    url: 'system/notice/my-notice',
    method: 'get',
    params: query
  })  
}
//消息读取
export function noticeRead(readId) {
  return request({
    url: 'system/notice/read/' + readId,
    method: 'get'
  })
}
//未读消息数量(小红点)//消息读取
export function noticeUnread() {
  return request({
    url: 'system/notice/unread',
    method: 'get'
  })
}

//消息列表
export function noticesList(query) {
  return request({
    url: 'system/notice/list',
    method: 'get',
    params: query
  })  
}

//新增
export function notice(data) {
  return request({
    url: 'system/notice',
    method: 'post',
    data: data
  })
}
//查询
export function queryNotice(noticeId) {
  return request({
    url: 'system/notice/'+ noticeId,
    method: 'get',
  })
}

//修改
export function upDataNotice(data) {
  return request({
    url: 'system/notice',
    method: 'put',
    data: data
  })
}
//删除
export function delNotice(noticeId) {
  return request({
    url: 'system/notice/' + noticeId,
    method: 'delete'
  })
}
//发布
export function noticePublish(noticeId) {
  return request({
    url: 'system/notice/publish/'+noticeId,
    method: 'put',
  })
}